import { combineReducers } from 'redux';

import {
  GOTO_STEP,
  ID_CARD,
  KYB_BANK_DATA,
  KYB_DATA,
  KYB_IDENTITY_DATA,
  NPWP_IMAGE,
} from '../../actions/kyb/constants';
import createReducer from '../../utils/createReducer';

const editMode = createReducer(false, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [GOTO_STEP]: (draft, { payload }) => payload.editMode,
});

const idCard = createReducer(null, {
  [ID_CARD]: (draft, { payload }) => payload,
});

const npwpImage = createReducer(null, {
  [NPWP_IMAGE]: (draft, { payload }) => payload,
});

const kybBankData = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [KYB_BANK_DATA]: (draft, { payload }) => payload.data,
});

const kybData = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [KYB_DATA]: (draft, { payload }) => payload.data,
});

const kybIdentity = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [KYB_IDENTITY_DATA]: (draft, { payload }) => payload.data,
});

const step = createReducer(0, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [GOTO_STEP]: (draft, { payload }) => payload.step,
});

export default combineReducers({
  editMode,
  idCard,
  kybBankData,
  kybData,
  kybIdentity,
  npwpImage,
  step,
});
